import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { motion } from 'framer-motion';
import { Dumbbell } from 'lucide-react';
import { getDifficultyLabel } from '../../utils/constants';

const categoryOptions = ['strength', 'hiit', 'cardio', 'yoga', 'core', 'full_body', 'upper_body', 'lower_body'];
const difficultyOptions = ['beginner', 'intermediate', 'advanced'];

export const WorkoutBasicInfo = ({ workout, updateField, isNew }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-card border border-border p-6"
    >
      <h2 className="font-heading text-2xl text-white uppercase tracking-wider mb-6">
        <Dumbbell className="inline h-5 w-5 mr-2 text-primary" />
        {isNew ? 'Create New Workout' : 'Edit Workout'}
      </h2>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div className="md:col-span-2">
          <Label className="text-white uppercase tracking-wider text-sm">Title</Label>
          <Input 
            value={workout.title}
            onChange={(e) => updateField('title', e.target.value)}
            className="mt-2 bg-black border-border text-white"
            data-testid="workout-title-input"
          />
        </div>
        
        <div>
          <Label className="text-white uppercase tracking-wider text-sm">Category</Label>
          <select 
            value={workout.category}
            onChange={(e) => updateField('category', e.target.value)}
            className="mt-2 w-full h-10 bg-black border border-border text-white px-3 rounded-md"
            data-testid="workout-category-select"
          >
            {categoryOptions.map(cat => (
              <option key={cat} value={cat} className="capitalize">{cat.replace('_', ' ')}</option>
            ))}
          </select>
        </div>
        
        <div>
          <Label className="text-white uppercase tracking-wider text-sm">Difficulty</Label>
          <select 
            value={workout.difficulty}
            onChange={(e) => updateField('difficulty', e.target.value)}
            className="mt-2 w-full h-10 bg-black border border-border text-white px-3 rounded-md capitalize"
            data-testid="workout-difficulty-select"
          >
            {difficultyOptions.map(opt => (
              <option key={opt} value={opt} className="capitalize">{getDifficultyLabel(opt)}</option>
            ))}
          </select>
        </div>
        
        <div>
          <Label className="text-white uppercase tracking-wider text-sm">Duration (minutes)</Label>
          <Input 
            type="number"
            value={workout.duration_minutes}
            onChange={(e) => updateField('duration_minutes', parseInt(e.target.value) || 0)}
            className="mt-2 bg-black border-border text-white"
            data-testid="workout-duration-input"
          />
        </div>
        
        <div>
          <Label className="text-white uppercase tracking-wider text-sm">Calories Burn</Label>
          <Input 
            type="number"
            value={workout.calories_burn}
            onChange={(e) => updateField('calories_burn', parseInt(e.target.value) || 0)}
            className="mt-2 bg-black border-border text-white"
            data-testid="workout-calories-input"
          />
        </div>
        
        <div className="md:col-span-2">
          <Label className="text-white uppercase tracking-wider text-sm">Description</Label>
          <Textarea 
            value={workout.description || ''}
            onChange={(e) => updateField('description', e.target.value)}
            className="mt-2 bg-black border-border text-white min-h-[80px]"
            data-testid="workout-description-input"
          />
        </div>
      </div>
    </motion.div>
  );
};
